import React from 'react';
import { SubHeaderContainer, SubHeaderContent, SubHeaderMenuItem } from "./ViewComponents";
import { BodyRegular } from "../../../../atoms/fonts/Body";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { redirectTo } from '@shared/store/auth.duck';
import { selectAllDepartments } from "@features/whereabouts/pages/departments/data/departments.duck";
import { useLockersEnabled } from "@features/whereabouts/pages/lockers/data/UseLockersEnabled";
import { useTranslation } from "react-i18next";

export function CompanyViewSubHeader(props: Props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const {t} = useTranslation();
  const departments = useSelector(selectAllDepartments);
  const lockersEnabled = useLockersEnabled();

  return (
    <SubHeaderContainer fullScreenView={props.fullScreenView}>
      <SubHeaderContent>
        <SubHeaderMenuItem selected={location.pathname.includes('/whereabouts/company/all')}
                           onClick={() => dispatch(redirectTo('/whereabouts/company/all'))}>
          <BodyRegular weight={600}>{t('company-view-page.all-teams')}</BodyRegular>
        </SubHeaderMenuItem>
        <SubHeaderMenuItem selected={location.pathname.includes('/whereabouts/company/workgroups')}
                           onClick={() => dispatch(redirectTo('/whereabouts/company/workgroups'))}>
          <BodyRegular weight={600}>{t('company-view-page.workgroups')}</BodyRegular>
        </SubHeaderMenuItem>
        {departments.length > 0 && <SubHeaderMenuItem selected={location.pathname.includes('/whereabouts/company/departments')}
                                                      onClick={() => dispatch(redirectTo('/whereabouts/company/departments'))}>
          <BodyRegular weight={600}>{t('team-view.departments')}</BodyRegular>
        </SubHeaderMenuItem>}
        {lockersEnabled && <SubHeaderMenuItem selected={location.pathname.includes('/whereabouts/company/lockers')}
                                              onClick={() => dispatch(redirectTo('/whereabouts/company/lockers'))}>
          <BodyRegular weight={600}>{t('lockers.title')}</BodyRegular>
        </SubHeaderMenuItem>}
      </SubHeaderContent>
    </SubHeaderContainer>
  )
}

interface Props {
  fullScreenView?: boolean;
}
